
import { filter } from 'rxjs/operators';
import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { ReleaseStatus } from '../../../../api/wire/enums/release-status.enum';
import { ButtonTypesEnum } from '../../../../Common/Forms/enums/button-types.enum';
import { AbstractPageBuilderService } from '../../../../Common/PageBuilder/services/abstract-page-builder.service';
import { CurrentUserStateService } from '../../../../Core/Users/services/current-user-state.service';
import { WireModel } from '../../models/wire.model';
import { WireService } from '../../services/wire.service';
import { ActionKeys } from '../../../../Common/Forms/enums/keys.enum';


@Component({
    selector: 'agpr-wire-header',
    templateUrl: './wire.header.component.html',
    styleUrls: ['./wire.header.component.scss'],
    standalone: false
})
export class WireHeaderComponent implements OnDestroy {
    private subscriptions: Subscription[] = [];
    wire: WireModel;

    readonly buttonTypes = ButtonTypesEnum;
    readonly releaseStatus = ReleaseStatus;

    @Input() editable: boolean = false;
    @Input() errorsId: string;

    @Output() clicked: EventEmitter<void> = new EventEmitter<void>();

    timezone: string;

    constructor(
        public wireService: WireService,
        public wirePageBuilderService: AbstractPageBuilderService,
        protected currentUserStateService: CurrentUserStateService
    ) {
        this.subscriptions.push(
            this.wireService.currentResource$.pipe(filter(x => !!x)).subscribe(wire => {
                this.wire = wire;
            }),
            this.currentUserStateService.getPreferences().pipe(filter(x => !!x)).subscribe(prefs => {
                this.timezone = prefs?.timeZone;
            })
        );
    }

    ngOnDestroy() {
        this.subscriptions.forEach(
            subscription => subscription.unsubscribe()
        );
    }

    emitClick(event?: any) {
        if (event instanceof KeyboardEvent && !(event.key === ActionKeys.ENTER || event.key === ActionKeys.SPACE)) {
            return;
        }
        if (this.editable) {
            this.wirePageBuilderService.deselectBlock(true);
            this.clicked.emit();
        }
    }
}
